import { Badge, message } from "antd";
import moment from 'moment';
import axiosInstance from "./axios";
import jwt from 'jwt-decode';
import dayjs from 'dayjs';
import qs from "query-string";
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

const invalidStringValue = "No proper value (invalid, inspect)";
const notEnteredStringTypeValue = "Not entered";

const unknownErrorGenericMessage = "An unknown error has occurred. Please try again later.";

export const UnknownErrorDisplayToCustomerMessage = unknownErrorGenericMessage;
export const UnknownErrorDisplayToInvoiceMessage = unknownErrorGenericMessage;
export const UnknownErrorDisplayToAccountLocationMessage = unknownErrorGenericMessage;
export const UnknownErrorDisplayToAccountUserMessage = unknownErrorGenericMessage;

export const updateUrlQueryString = (newValues, search, history) => {
  const values = qs.parse(search);
  const newQsValue = qs.stringify({
    ...values,
    ...newValues,
  });
  history.push({
    search: newQsValue,
    pathname: history.location.pathname,
  });
}

export const displayBackendApiError = (err, defaultMessage = UnknownErrorDisplayToCustomerMessage) => {
  message.error(JSON.stringify(err?.response?.data?.detail) || defaultMessage);
}

export const badgeElement = (text, count) => {
  return (
    <Badge offset={[13, 0]} count={count}>
      {text}
    </Badge>
  )
}

export const showValueOrDefault = (value, defaultValue = notEnteredStringTypeValue) => {
  return value || (
    <i>{defaultValue}</i>
  );
}

export const truncate = (str, n) => {
  return (str.length > n) ? str.slice(0, n - 1) + '…' : str;
};

export const isNumber = (value) => {
  if ((undefined === value) || (null === value)) {
    return false;
  }
  if (typeof value == 'number') {
    return true;
  }
  return !isNaN(value - 0);
}

export const IsString = (x) => {
  return Object.prototype.toString.call(x) === "[object String]"
}

export const replaceCharacter = (str, index, replaceChar = "") => {
  return str.substring(0, index) + replaceChar + str.substring(index + 1);
}

export const capitalizeFirstLetterLowercaseRest = (string) => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
}

export const compareStringsCaseInsensitiveTrimmed = (s1, s2) => {
  s1 = s1.toLowerCase().trim();
  s2 = s2.toLowerCase().trim();
  return s1 === s2;
}

export const nicelyFormatSnakeCaseString = (string) => {
  const pascalCaseString = snakeCaseToPascal(string);
  if (pascalCaseString === invalidStringValue) {
    return invalidStringValue;
  }
  return nicelyFormatPascalCaseString(pascalCaseString);
}

export const snakeCaseToPascal = (string) => {
  if (string === null || string === undefined) return invalidStringValue;
  return string.split("/")
    .map(snake => snake.split("_")
      .map(substr => substr.charAt(0)
        .toUpperCase() +
        substr.slice(1))
      .join(""))
    .join("/");
};

export const nicelyFormatPascalCaseString = (camelCaseString) => {
  if (camelCaseString === null || camelCaseString === undefined) return invalidStringValue;
  return camelCaseString
    // insert a space before all caps
    .replace(/([A-Z])/g, ' $1')
    // uppercase the first character
    .replace(/^./, function (str) { return str.toUpperCase(); })
}

export const isNumeric = (str) => {
  if (typeof str != "string") return false // only strings
  return !isNaN(str) &&
    !isNaN(parseFloat(str)) // ensure strings of whitespace fail
}

export const roundNumber = (number, decimals = 12) => {
  // eslint-disable-next-line no-new-wrappers
  var newNumber = new Number(number + '').toFixed(parseInt(decimals));
  return parseFloat(newNumber);
}

export const objectsEqual = (o1, o2) => {
  return Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(p => o1[p] === o2[p]);
}